import React, { useRef, useEffect, useState } from "react";
import "./Style.css";
import { Helmet } from 'react-helmet';
import aboutUsOne from './assets/about-us-one.jpg'; // Add the About section image
import aboutImage from './assets/about-img-2.jpg'; // Add the About section image
import aboutimageposition from './assets/about-img-3.jpg'; // Add the About section image
import counterone from './assets/counter-one.png'; // Add the About section image
import countertwo from './assets/counter-two.png'; // Add the About section image
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

import teamOne from "./assets/team-1.png";
import teamTwo from "./assets/team-2.png";
import teamThree from "./assets/team-3.png";
import teamFour from "./assets/team-4.png";
import user from "./assets/user.jpg";

import testiAuthorOne from './assets/testi-author-1.png'; // Add the About section image
import testiAuthorTwo from './assets/testi-author-2.png'; // Add the About section image
import testiAuthorThree from './assets/testi-author-3.png'; // Add the About section image

const About = () => {

    // starts About Us section
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };
    // Ends About Us section

    // starts Work Proccess section
    const services = [
        {
            id: "01",
            title: "Client Consultation",
            description: "Our process begins with an in-depth consultation to fully grasp your brand vision, goals, and target audience. This ensures that every step aligns with your business identity.",
            link: "#",
        },
        {
            id: "02",
            title: "Research and Analysis",
            description: "We analyze market trends, competitor strategies, and audience behaviors to create a branding and marketing approach that positions your business for success.",
            link: "#",
        },
        {
            id: "03",
            title: "Project Revisions Launch",
            description: "We work closely with you throughout the project, refining every detail based on your feedback. Once finalized, we launch with confidence, ensuring your brand makes a lasting impact.",
            link: "#",
        },
    ];
    // Ends Work Proccess section

    // start Marqee section
    const marqueeRef = useRef(null);
    const speed = 20; // Speed in seconds

    useEffect(() => {
        const marquee = marqueeRef.current;

        if (marquee) {
            marquee.style.animationDuration = `${speed}s`;

            // Pause marquee on mouse hover
            const handleMouseOver = () => {
                marquee.style.animationPlayState = "paused";
            };

            const handleMouseOut = () => {
                marquee.style.animationPlayState = "running";
            };

            marquee.addEventListener("mouseover", handleMouseOver);
            marquee.addEventListener("mouseout", handleMouseOut);

            return () => {
                marquee.removeEventListener("mouseover", handleMouseOver);
                marquee.removeEventListener("mouseout", handleMouseOut);
            };
        }
    }, [speed]);
    // ends Marqee section

    // starts Clients Feedback section
    const teamMembers = [
        {
            name: '— Sarah Mitchell, Founder of GreenTech Solutions',
            role: 'Exceptional Web Development Services',
            description: '"Working with dotlocalhost has been an absolute pleasure! Their team took the time to understand our business needs and created a stunning website that exceeded our expectations. The design is sleek, user-friendly, and perfectly represents our brand. They delivered on time and kept us updated throughout the process. Highly recommended!"',
            image: testiAuthorTwo, // Replace with actual images
        },
        {
            name: '— James Carter, CEO of Urban Eats',
            role: 'Outstanding Social Media Marketing',
            description: '"Dotlocalhost transformed our social media presence! Their team developed a creative and effective marketing strategy that boosted our engagement and brought in new customers. The results have been phenomenal, and their professionalism and expertise are unmatched. We couldn’t be happier with their work!"',
            image: testiAuthorOne, // Replace with actual images
        },
        {
            name: 'Roberts William, Marketing Manager at Luxe Interiors',
            role: 'Creative Graphic Designing and Performance Marketing',
            description: '"The graphic design team at dotlocalhost is incredibly talented! They designed eye-catching visuals for our campaigns that truly captured our brand’s essence. Combined with their performance marketing expertise, our sales skyrocketed within weeks. They’re a one-stop solution for all digital needs!"',
            image: testiAuthorThree, // Replace with actual images
        },
    ];
    // Ends Clients Feedback section


    return (
        <>
            {/* Meta title and descriptions */}
            <Helmet>
                <title>About DotLocalHost - Our Mission for Web Excellence & Innovation</title>
                <meta
                    name="description"
                    content="Learn about DotLocalHost’s passion for empowering businesses with top-tier web development and hosting solutions. Discover our story, values, and commitment to your success!"
                />
            </Helmet>
            {/* Banner Section */}
            <section className="aboutUs-section">
                <div className="aboutUs-overlay">
                    <div className="aboutUs-content">
                        <h1 className="aboutUs-title">About Us</h1>
                        <p className="aboutUs-breadcrumb">
                            <span>Dot LocalHost</span> &gt; <span>About</span>
                        </p>
                    </div>
                </div>
            </section>

            {/* Company Us */}
            <div className="company-section py-5">
                <div className="container">
                    <div className="row align-items-center">
                        {/* Left Text Column */}
                        <div className="col-md-6 text-column">
                            <p className="section-tagline">ABOUT US</p>
                            <h2>Why Businesses Across the US Choose Our Digital Solutions</h2>
                            <p>We provide tailored, results-driven strategies that empower businesses to grow, compete, and succeed in the digital age. Our expertise in web development, digital marketing, and branding makes us the go-to partner for companies looking to dominate their market.</p>
                            <p><b>Partner-Centric Solutions for Business Growth</b></p>
                            <p>We treat your business as our own, ensuring that every strategy is designed to help you scale. Our team of experts seamlessly integrates your ideas into social media, paid advertising, and website channels—executing each plan with precision. This commitment to excellence is why our clients trust and love working with us.</p>

                            {/* Accordion Section */}
                            <div className="accordion">
                                <div className="accordion-item">
                                    <button
                                        className={`accordion-header ${activeIndex === 0 ? 'active' : ''}`}
                                        onClick={() => toggleAccordion(0)}
                                    >
                                        → Tell your brands' story through 'Social Media'
                                    </button>
                                    <div className={`accordion-body ${activeIndex === 0 ? 'show' : ''}`}>
                                        <p><b>Full-Service Social Media Management</b></p>
                                        <p>We specialize in managing Facebook, Instagram, Twitter, LinkedIn, YouTube, and Pinterest. Our process starts with an in-depth brand audit, followed by a content strategy tailored to your audience. Once approved, our design team creates compelling visuals using data-driven insights. We also handle community management, ensuring timely engagement with your audience.</p>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <button
                                        className={`accordion-header ${activeIndex === 1 ? 'active' : ''}`}
                                        onClick={() => toggleAccordion(1)}
                                    >
                                        → Website Design
                                    </button>
                                    <div className={`accordion-body ${activeIndex === 1 ? 'show' : ''}`}>
                                        <p><b>Cutting-Edge Web Development for Every Business</b></p>
                                        <p>Dotlocalhost is a US-focused web development agency with highly skilled developers across various industries. Whether you need an eCommerce store, lead generation site, or a dynamic business website, we have the expertise to bring your vision to life.</p>
                                        <li><b>Mobile-First & Responsive Design</b> – Your website will look perfect on desktops, tablets, and mobile devices.</li>
                                        <li><b>User-Centric & High-Converting Layouts</b> – We optimize designs to drive engagement and conversions.</li>
                                        <li><b>End-to-End eCommerce Setup</b> – We ensure seamless product listing, payment gateways, and conversion tracking for scalable growth.</li>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <button
                                        className={`accordion-header ${activeIndex === 2 ? 'active' : ''}`}
                                        onClick={() => toggleAccordion(2)}
                                    >
                                        → Graphic Design
                                    </button>
                                    <div className={`accordion-body ${activeIndex === 2 ? 'show' : ''}`}>
                                        <p><b>Industry-Leading Graphic Design & Branding</b></p>
                                        <p>With over <b>8 years of experience,</b> our designers specialize in <b>packaging, web design, logos, outdoor branding, and social media graphics.</b> We now also offer <b>custom apparel designs</b> for t-shirts, caps, and hoodies. We prioritize creativity, attention to detail, and extensive collaboration to create high-impact branding solutions.</p>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <button
                                        className={`accordion-header ${activeIndex === 3 ? 'active' : ''}`}
                                        onClick={() => toggleAccordion(3)}
                                    >
                                        → Financial Services
                                    </button>
                                    <div className={`accordion-body ${activeIndex === 3 ? 'show' : ''}`}>
                                        <p><b>In-Depth Market & Investor Research</b></p>
                                        <p>We conduct industry research using Pitchbook Venture Capital, Private Equity, and M&A Database, as well as CapitalIQ. Our analysis includes:</p>
                                        <li>✔ Competitor Market Overview</li>
                                        <li>✔ Investor Lists with Contact Details</li>
                                        <li>✔ Public/M&A Comparative Analysis</li>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Image Column */}
                        <div className="col-md-6">
                            <img src={aboutUsOne} alt="About Us" className="img-fluid about-image" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Company Section */}
            <div className="company-section py-5">
                <div className="container">
                    <div className="row align-items-center">
                        {/* Left Image Column */}
                        <div className="col-md-6">
                            <img src={aboutImage} alt="About Us" className="img-fluid about-image" />
                            <img src={aboutimageposition} alt="About Us" className="img-fluid aboutus-possison" />
                        </div>
                        {/* Right Text Column */}
                        <div className="col-md-6 text-column">
                            <p className="aboutSectionTagline">ABOUT COMPANY</p>
                            <h2>Our Mission: 100% Client Satisfaction</h2>
                            <p>We are committed to delivering outstanding results for both local and global clients, helping businesses achieve long-term success through innovative digital solutions.</p>
                            <p><b>Custom IT Solutions Tailored to Your Business</b></p>
                            <p>We offer bespoke IT design, management, and support to ensure your business runs efficiently. From system optimization to software integration, we help brands stay ahead in today’s tech-driven world.</p>

                            <div className="container py-5">
                                <div className="row justify-content-center">
                                    {/* Counter 1 */}
                                    <div className="col-12 col-md-5 text-center border p-4 m-2">
                                        <img src={counterone} alt="Counter 1" className="img-fluid mb-3 section-icon" />

                                        <p>Professional Creative
                                            Team Members</p>
                                    </div>

                                    {/* Counter 2 */}
                                    <div className="col-12 col-md-5 text-center border p-4 m-2">
                                        <img src={countertwo} alt="Counter 2" className="img-fluid mb-3 section-icon" />

                                        <p>Provide Market Standard
                                            Service to Client’s</p>
                                    </div>
                                </div>
                            </div>

                            <button className="btn cta-button">Get Started Now</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Work Proccess Section */}
            <div className="work-section py-5">
                <div className="container">
                    <p className="section-work-tagline ">WORK PROCESS</p>
                    <h2>High-Quality Services to Elevate Your Brand Identity</h2>
                    <p>We specialize in branding strategies that make an impact, helping businesses build strong, recognizable identities that drive growth and customer loyalty.</p>

                    <div className="services-section">
                        {services.map((service) => (
                            <div className="service-card" key={service.id}>
                                <div className="service-id">{service.id}</div>
                                <h3 className="service-title">{service.title}</h3>
                                <p className="service-description">{service.description}</p>
                                {/*                                 
                                <a href={service.link} className="service-link">
                                    Read More <span>&#8250;&#8250;</span>
                                </a>
*/}
                            </div>
                        ))}
                    </div>

                </div>
            </div>

            {/* Simple Card Section */}
            <div className="simple-card-section py-5">
                <div className="container">

                    <div className="row mt-5 simpleCard">
                        <div className="col-md-3 simple-card-one">
                            <div className="row">
                                <div className="col-6">

                                </div>
                                <div className="col-6">
                                    <p>Years of</p>
                                    <p>Experience</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 simple-card-two">
                            <div className="row">
                                <div className="col-6">

                                </div>
                                <div className="col-6">
                                    <p>Sillded</p>
                                    <p>Perforamce</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 simple-card-three">
                            <div className="row">
                                <div className="col-6">

                                </div>
                                <div className="col-6">
                                    <p>Visited</p>
                                    <p>Conference</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 simple-card-four">
                            <div className="row">
                                <div className="col-6">

                                </div>
                                <div className="col-6">
                                    <p>Years of</p>
                                    <p>Experience</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* Marqee Section */}
            {/*            
            <div className="marqee-section py-5">
                <div className="">
                    <div className="marquee-container">
                        <div className="marquee" ref={marqueeRef}>
                            <span>Latest Projects</span>
                            <span>Web Development</span>
                            <span>Latest Projects</span>
                            <span>Web Development</span>
                            <span>Latest Projects</span>
                            <span>Web Development</span>
                        </div>
                    </div>
                </div>
            </div>
*/}

            {/* Team Members Section */}
            <div className="team-mambers-section py-5">
                <div className="container">
                    <p className="section-tagline">TEAM MEMBERS</p>
                    <h2 className="mb-5">EXPERIENCE TEAM MEMBER</h2>

                    <div className="row mt-5 team-card">

                        <div className="col-md-3 team-card-one">
                            <div className="team-card-wrapper">
                                <img src={user} alt="Charlotte Amitina" className="img-fluid mb-3" />
                                <div className="overlay">
                                    <div className="social-icons">
                                        <a href="https://www.facebook.com/DotLocalHost/" className="icon" target="_blank"><FaFacebook /></a>
                                        <a href="#" className="icon" target="_blank"><FaLinkedin /></a>
                                    </div>
                                </div>
                            </div>
                            <h3>Charlotte Amitina</h3>
                            <p>Ui/Ux Designer</p>
                        </div>

                        <div className="col-md-3 team-card-two">
                            <div className="team-card-wrapper">
                                <img src={user} alt="William Edward" className="img-fluid mb-3" />
                                <div className="overlay">
                                    <div className="social-icons">
                                        <a href="https://www.facebook.com/DotLocalHost/" className="icon" target="_blank"><FaFacebook /></a>
                                        <a href="#" className="icon" target="_blank"><FaLinkedin /></a>
                                    </div>
                                </div>
                            </div>
                            <h3>William Edward</h3>
                            <p>Project Manager</p>
                        </div>

                        <div className="col-md-3 team-card-three">
                            <div className="team-card-wrapper">
                                <img src={user} alt="Hannah Chloe" className="img-fluid mb-3" />
                                <div className="overlay">
                                    <div className="social-icons">
                                        <a href="https://www.facebook.com/DotLocalHost/" className="icon" target="_blank"><FaFacebook /></a>
                                        <a href="#" className="icon" target="_blank"><FaLinkedin /></a>
                                    </div>
                                </div>
                            </div>
                            <h3>Hannah Chloe</h3>
                            <p>Product Designer</p>
                        </div>

                        <div className="col-md-3 team-card-four">
                            <div className="team-card-wrapper">
                                <img src={user} alt="Maiselan Willam" className="img-fluid mb-3" />
                                <div className="overlay">
                                    <div className="social-icons">
                                        <a href="https://www.facebook.com/DotLocalHost/" className="icon" target="_blank"><FaFacebook /></a>
                                        <a href="#" className="icon" target="_blank"><FaLinkedin /></a>
                                    </div>
                                </div>
                            </div>
                            <h3>Maiselan Willam</h3>
                            <p>Web Developer</p>
                        </div>

                    </div>

                </div>
            </div>

            {/* Clients Feedback Section */}
            <div className="work-section py-5">
                <div className="container">
                    <p className="section-work-tagline ">TESTIMONIALS</p>
                    <h2>CLIENTS FEEDBACK</h2>

                    <div className="team-section">
                        {teamMembers.map((member, index) => (
                            <div className="team-member" key={index}>
                                <img src={member.image} alt={`${member.name}`} className="team-image" />
                                <p className="team-role">{member.role}</p>
                                <p className="team-description">{member.description}</p>
                                <h3 className="team-name">{member.name}</h3>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </>
    )
}

export default About;